import { Droplets, Wrench, Leaf, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function GardenCareForAWellMaintainedOutdoorArea() {
  const services = [{
    title: "Flächenreinigung ohne chemische Zusätze",
    description: "Professionelle Reinigung von Terrassen, Einfahrten, Pflaster und anderen Flächen – ausschließlich mit Wasser, umweltfreundlich und materialschonend.",
    icon: Droplets,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_eco_friendly_water_only.png"
  }, {
    title: "Hausmeistertätigkeiten",
    description: "Zuverlässiger Hausmeisterservice im nicht handwerkspflichtigen Bereich – für die Pflege und Instandhaltung Ihrer Immobilien und Außenanlagen.",
    icon: Wrench,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/caretaker_services_property_maintenance.png"
  }, {
    title: "Gartenpflege",
    description: "Umfassende Gartenpflege mit Hecken- und Rasenschnitt, Strauchschnitt, Laubbeseitigung und saisonaler Pflege für gepflegte Außenbereiche.",
    icon: Leaf,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_care_maintenance_landscaping.png"
  }, {
    title: "Bürotätigkeiten und Organisation",
    description: "Professionelle Unterstützung bei Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation für einen effizienten Arbeitsalltag.",
    icon: Briefcase,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_administrative_support.png"
  }];
  return <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="text-center mb-12 lg:mb-16 animate-fade-in-up">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Unsere vier Leistungsbereiche
          </h2>
          <p className="text-base lg:text-lg text-muted-dark max-w-3xl mx-auto leading-relaxed">
            Münsterland Industrieservice bietet vielseitige Dienstleistungen im Münsterland: Flächenreinigung, Hausmeisterservice, Gartenpflege und Büroorganisation – alles aus einer Hand.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="border border-border shadow-soft hover-lift bg-muted-light overflow-hidden animate-fade-in-up" style={{
            animationDelay: `${i * 100}ms`
          }}>
                <div className="relative h-48 lg:h-56 bg-cover bg-center" style={{
              backgroundImage: `url(${service.image})`
            }}>
                  <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <CardHeader>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="p-2.5 bg-primary/10 rounded-lg">
                      <Icon className="size-5 text-primary" />
                    </div>
                    <CardTitle className="text-xl lg:text-2xl">{service.title}</CardTitle>
                  </div>
                  <CardDescription className="text-sm lg:text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>;
        })}
        </div>

        {}
        <div className="text-center bg-muted-light rounded-xl p-8 lg:p-12 border border-border shadow-soft animate-fade-in-up-delay-200">
          <h3 className="text-2xl lg:text-3xl font-semibold text-foreground mb-4">
            Bereit für professionelle Dienstleistungen?
          </h3>
          <p className="text-muted-dark text-base lg:text-lg mb-6 max-w-2xl mx-auto leading-relaxed">
            Kontaktieren Sie uns für ein kostenloses Angebot – ob Reinigung, Hausmeisterservice, Gartenpflege oder Büroorganisation.
          </p>
          <Link to="/KontaktPage">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover shadow-medium transition-all duration-[var(--duration-medium)]">
              Kostenloses Angebot anfordern
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}